import VolumeContextBase from "./volumeContextBase";
import store from "../store";
import { COLOR_TYPE } from "../config/config";

export default class CirrusContext extends VolumeContextBase {
  constructor(group, exam) {
    super(group, exam, "cirrusBrowserBody", "Cirrus Browser");

    this.showHD = false;
    this.showETDRS = true;
    
    if (store.getters.userPrefCirrusView == COLOR_TYPE.color)
      this.toggleColorPalette();
  }

  getSliceDimensions(sliceInfo) {
    let sliceDimensions = sliceInfo && sliceInfo.dimensions || {};
    return { w: sliceDimensions.pixelWidth || 0, h: sliceDimensions.pixelHeight || 0 };
  }

  toggleHD() {
    this.showHD = !this.showHD;
  }

  centerFovea() {
    let numSlices = store.getters.slices.length;
    let sliceIndex = Math.floor(numSlices * this.foveaOffset.y);
    let numCompositeSlices = store.getters.composites.length;
    let compositeCurrentIndex = Math.floor(numCompositeSlices * this.foveaOffset.x);

    store.dispatch("selectOCTImageByIndex", {
      currentKey: "sliceCurrent",
      collectionKey: "slices",
      keyword: "slice",
      index: sliceIndex
    });
    store.dispatch("selectOCTImageByIndex", {
      currentKey: "compositeCurrent",
      collectionKey: "composites",
      keyword: "composite",
      index: compositeCurrentIndex
    });
  }

  toggleETDRS() {
    this.showETDRS = !this.showETDRS;
  }
}